import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import * as moment from 'moment-timezone';
import { timeZone } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-trip-listing',
  templateUrl: './trip-listing.component.html',
  styleUrls: ['./trip-listing.component.css']
})
export class TripListingComponent implements OnInit {
  search: any;
  @Input() trips: any
  @Output() dateWiseTrips = new EventEmitter<any>;
  @Output() statusWiseTrips = new EventEmitter<string>();
  preLevelOfServiceList: any = {}
  preSpaceTypeList: any = {}
  preAppointmentTypes: any = {}
  currentPage = 1;
  preMembers: any = {};
  todayDate: any = [];
  timeZone: any = timeZone;
  user: any;
  selectedStatus = 'scheduled';
  
  statuses: any = [
    { value: 'scheduled', label: 'Scheduled' },
    { value: 'offered', label: 'Offered' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'onway', label: 'On Way' },
    { value: 'arrived', label: 'Arrived' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'marketplace', label: 'Marketplace' },
    { value: 'reroute', label: 'Reroute' },
  ];

  constructor(
    private sharedDataService: SharedDataService,
    private appointmentType: AppointmentTypeService,
    private levelOfService: LosService,
    private spaceType: SpaceTypeService
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.getAppointmentTypes();
    this.getSpaceTypes();
    this.getLevelOfService();
  }

  getUser() {
    this.sharedDataService.getUser().pipe().subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        this.todayDate = [
          moment().tz(this.timeZone).startOf("day"),
          moment().tz(this.timeZone).add(7, "days").endOf("day").toDate()
        ];
      }

    })
  }

  getAppointmentTypes() {
    this.appointmentType.getPicker({ isActive: true, limit: 999 }).subscribe((data: any) => {
      if (data && data.results) {
        this.preAppointmentTypes = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});

      }
    })
  }

  getLevelOfService() {
    this.levelOfService.getPicker({ isActive: true, limit: 999 }).subscribe((data: any) => {
      if (data && data.results) {
        this.preLevelOfServiceList = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getSpaceTypes() {
    this.spaceType.getPicker({ isActive: true, limit: 999 }).subscribe((data: any) => {
      if (data && data.results) {
        this.preSpaceTypeList = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }
  
  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.dateWiseTrips.emit(this.todayDate);
  }

  selectStatus() {
    this.statusWiseTrips.emit(this.selectedStatus);
  }
}
